import React from "react";

import PageContent from "2g-page-content";

import ProvozniInformaceWidget from "b2b/components/provozni-informace-widget";

function ProvozniInformace() {
  return (
    <PageContent>
      <ProvozniInformaceWidget />
    </PageContent>
  );
}

export default React.memo(ProvozniInformace);
